// extracted by mini-css-extract-plugin
export default {"flex_column":"QingError_flex_column__McKyH","empty":"QingError_empty__dcaPH","warning_icon":"QingError_warning_icon__0fTTr","msg":"QingError_msg__Xxe5M"};